export const formatPriceToCents = (price: number | string) => {
  // Normalise the incoming value into a number so we can operate on both strings and numbers.
  const numericPrice = Number(price);

  // Guard against NaN inputs; downstream callers expect a numeric result.
  if (Number.isNaN(numericPrice)) {
    return 0;
  }

  // Convert dollars to cents
  const priceInCents = numericPrice * 100;

  // Round to the nearest thousandth so values like 33.33333 become 3333.333.
  return Math.round((priceInCents + Number.EPSILON) * 1_000) / 1_000;
};
